import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'

import { pricingAPI } from '../../api/services/pricing'
import {
  PricesList,
  PricingData,
  PricingResponse
} from '../../api/services/pricing/types.ts'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import PricesGroup from '../../components/payments/PricesGroup.tsx'
import { useAuth } from '../../context/auth'
import { usePriceListFormik } from '../../hooks/usePriceListFormik.ts'

const PriceList = () => {
  const { state } = useAuth()
  const [changeStatus, setChangeStatus] = useState(false)
  const [mainPrices, setMainPrices] = useState<PricesList[]>([])
  const [userPrices, setUserPrices] = useState<PricesList[]>([])
  const [defaultReset, setDefaultReset] = useState(false)
  const [defaultPrices, setDefaultPrices] = useState({
    price1m: 100,
    price3m: 300,
    price6m: 600,
    price12m: 1200
  })

  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    changeStatus && setRefreshKey(refreshKey + 1)
    changeStatus && setChangeStatus(false)
  }, [changeStatus])

  const fetchData = async () => {
    const response: PricingResponse<PricingData> | null =
      await pricingAPI.getPricing()

    const data = response.data

    if (data) {
      if (data.main_account_pricing !== null) {
        setMainPrices([data.main_account_pricing])

        if (data.user_pricing !== null) {
          setUserPrices([data.user_pricing])
        } else {
          data.main_account_pricing &&
            setUserPrices([data.main_account_pricing])
        }
      } else {
        if (data.user_pricing !== null) {
          setUserPrices([data.user_pricing])
        } else {
          setUserPrices([
            {
              month_diet_price: defaultPrices.price1m.toString(),
              three_month_diet_price: defaultPrices.price3m.toString(),
              six_month_diet_price: defaultPrices.price6m.toString(),
              twelve_month_diet_price: defaultPrices.price12m.toString()
            }
          ])
        }
      }
    }

    return response.data
  }

  const { isLoading, isError } = useQuery({
    queryKey: ['priceList', refreshKey, state.email],
    queryFn: fetchData
  })

  if (isError) {
    return <div>Wystąpił błąd podczas zapytania na serwer</div>
  }

  if (mainPrices.length > 0 && defaultPrices.price1m === 100 && !defaultReset) {
    setDefaultReset(true)
    setDefaultPrices({
      price1m: Number(mainPrices[0].month_diet_price),
      price3m: Number(mainPrices[0].three_month_diet_price),
      price6m: Number(mainPrices[0].six_month_diet_price),
      price12m: Number(mainPrices[0].twelve_month_diet_price)
    })
  }

  const formik = usePriceListFormik(
    userPrices,
    mainPrices,
    defaultPrices,
    setChangeStatus
  )

  return (
    <>
      <Breadcrumbs pageName="Cennik diet" breadcrumbs={[]} />
      <Card>
        <Card.Body>
          {isLoading && <Loader label={'Pobieranie danych...'} />}

          {!isLoading && mainPrices.length > 0 && formik && (
            <div className="mb-10 p-4 border-2 ">
              <p className="text-xl font-bold mb-4 p-4 bg-blue-50 dark:bg-blue-900">
                Ceny domyślne
              </p>
              <PricesGroup
                formik={formik}
                isDisabled={true}
                data={{
                  price1m: Number(mainPrices[0].month_diet_price),
                  price3m: Number(mainPrices[0].three_month_diet_price),
                  price6m: Number(mainPrices[0].six_month_diet_price),
                  price12m: Number(mainPrices[0].twelve_month_diet_price)
                }}
              />
            </div>
          )}
          {!isLoading && userPrices.length > 0 && formik && (
            <div className="mb-10 p-4">
              <p className="text-xl font-bold mb-4 p-4 bg-green-50 dark:bg-green-700">
                Twoje ceny
              </p>
              <PricesGroup
                formik={formik}
                isDisabled={false}
                data={formik.initialValues}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  )
}

export default PriceList
